export const OPTIONS = [
    {
        path: '/home',
        title: 'dashboard',
        type: 'link',
        icontype: 'fas fa-home fa-2x',
        abilities: ['index-home'],
    },
    {
        path: '/admin/terms-conditions',
        title: 'termsConditions',
        type: 'link',
        icontype: 'fas fa-file fa-2x',
        abilities: ['list.terms-conditions'],
    },
    {
        path: '/admin/banners',
        title: 'banners',
        type: 'link',
        icontype: 'fas fa-image fa-2x',
        abilities: ['list.sliders'],
    },
    {
        path: '/admin/search-settings',
        title: 'searchSettings',
        type: 'link',
        icontype: 'fas fa-ruler-combined fa-2x',
        abilities: ['view.search-settings'],
    },
    {
        path: '',
        title: 'users',
        type: 'father',
        icontype: 'fas fa-users fa-2x',
        isCollapsed: true,
        abilities: ['list.clients', 'list.providers', 'list.managers'],
        children: [
            {
                path: '/admin/clients',
                title: 'clients',
                type: 'sub',
                icontype: 'fas fa-user fa-2x',
                abilities: ['list.clients'],
            },
            {
                path: '/admin/providers',
                title: 'providers',
                type: 'sub',
                icontype: 'fas fa-user fa-2x',
                abilities: ['list.providers'],
            },
            {
                path: '/admin/managers',
                title: 'managers',
                type: 'sub',
                icontype: 'fas fa-user fa-2x',
                abilities: ['list.managers'],
            },
            {
                path: '/admin/sellers',
                title: 'sellers',
                type: 'sub',
                icontype: 'fas fa-user fa-2x',
                abilities: ['list.seller'],
            },
        ],
    },
    {
        path: '',
        title: 'catalogs',
        type: 'father',
        icontype: 'fas fa-cubes fa-2x',
        isCollapsed: true,
        abilities: [ 'list.business', 'list.categories', 'list.event-prom-category', 'list.subcategories', 'list.sub-subcategories', 'list.catalogs', 'list.events', 'list.promotions'],
        children: [
            {
                path: '/admin/business',
                title: 'businessMenu',
                type: 'sub',
                icontype: 'fas fa-cube fa-2x',
                abilities: ['list.business'],
            },
            {
                path: '/admin/categories',
                title: 'categories',
                type: 'sub',
                icontype: 'fas fa-cube fa-2x',
                abilities: ['list.categories'],
            },
            {
                path: '/admin/categories-event-promo',
                title: 'categoriesEP',
                type: 'sub',
                icontype: 'fas fa-cube fa-2x',
                abilities: ['list.event-prom-category'],
            },
            {
                path: '/admin/subcategories',
                title: 'subcategories',
                type: 'sub',
                icontype: 'fas fa-cube fa-2x',
                abilities: ['list.subcategories'],
            },
            {
                path: '/admin/sub-subcategories',
                title: 'sub-subcategories',
                type: 'sub',
                icontype: 'fas fa-cube fa-2x',
                abilities: ['list.sub-subcategories'],
            },
            {
                path: '/admin/services',
                title: 'services',
                type: 'sub',
                icontype: 'fas fa-cube fa-2x',
                abilities: ['list.catalogs'],
            },
            {
                path: '/admin/events',
                title: 'events',
                type: 'sub',
                icontype: 'fas fa-bell fa-2x',
                abilities: ['list.events'],
            },
            {
                path: '/admin/promotions',
                title: 'promotions',
                type: 'sub',
                icontype: 'fas fa-cube fa-2x',
                abilities: ['list.promotions'],
            },
        ],
    },
];
